/**
 * EventLog - Container for all events, displays newest at bottom
 */

import { Code } from "lucide-react"
import { observer } from "mobx-react"
import type { CodeEvent } from "../types"
import { EventItem } from "./EventItem"

export const EventLog = observer(({ taskId, events, loading, error }: { taskId: string; events: CodeEvent[]; loading?: boolean; error?: string | null }) => {
    if (events.length === 0) {
        return (
            <div className="h-full flex flex-col items-center justify-center text-muted px-8 py-16">
                <Code size="3rem" className="mb-4 opacity-30" />
                <div className="text-lg font-medium mb-2">{loading ? "Loading activity..." : "No activity yet"}</div>
                <div className="text-sm text-center">
                    {error ?? (loading ? "Reading provider session events from Nest." : "Enter a task description below and click Do to get started.")}
                </div>
            </div>
        )
    }

    return (
        <div className="flex flex-col">
            {events.map((event) => (
                <EventItem key={event.id} taskId={taskId} event={event} />
            ))}
        </div>
    )
})
